export const EXCLUDED_REVIEWER = ["daniel@codelink.io", "ka@codelink.io"];
